import { timelineFeature } from "@/pages/home/data";

function kindInfo(kind: string) {
  if (kind === "rumor")
    return { label: "传言发酵", cls: "bg-secondary-500 text-background-50", dot: "bg-secondary-400" };
  if (kind === "fact")
    return { label: "事实核查", cls: "bg-accent-500 text-background-50", dot: "bg-accent-400" };
  return { label: "编辑部复盘", cls: "bg-primary-500 text-background-50", dot: "bg-primary-400" };
}

export default function TruthTimeline() {
  return (
    <section id="truth" className="scroll-anchor bg-foreground-950 py-14 text-background-50 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-12">
          {/* 左侧说明 */}
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
              <i className="ri-flask-line" aria-hidden="true"></i>
              {timelineFeature.eyebrow}
            </span>
            <h2 className="mt-5 font-heading text-2xl font-black leading-tight md:text-4xl">
              {timelineFeature.title}
            </h2>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100/75 md:text-base">
              {timelineFeature.intro}
            </p>

            <div className="mt-7 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-100/80">
                <span className="h-2 w-2 rounded-full bg-secondary-400"></span>
                传言发酵
              </span>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-100/80">
                <span className="h-2 w-2 rounded-full bg-accent-400"></span>
                事实核查
              </span>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-100/80">
                <span className="h-2 w-2 rounded-full bg-primary-400"></span>
                编辑部复盘
              </span>
            </div>

            <p className="mt-8 rounded-lg border border-background-50/10 bg-background-50/5 p-4 text-xs leading-relaxed text-background-100/60">
              {timelineFeature.footnote}
            </p>
          </div>

          {/* 右侧时间线 */}
          <div className="lg:col-span-7">
            <ol className="relative ml-2 border-l border-background-50/15 md:ml-4">
              {timelineFeature.nodes.map((n) => {
                const info = kindInfo(n.kind);
                return (
                  <li key={n.phase} className="relative pb-10 pl-8 last:pb-0 md:pl-10">
                    <span
                      className={"absolute left-0 top-1.5 flex h-3.5 w-3.5 -translate-x-1/2 items-center justify-center rounded-full " + info.dot}
                    ></span>
                    <div className="flex flex-wrap items-center gap-3">
                      <h3 className="font-heading text-lg font-bold md:text-xl">{n.phase}</h3>
                      <span className="flex items-center gap-1 text-xs text-background-100/60">
                        <i className="ri-time-line" aria-hidden="true"></i>
                        {n.time}
                      </span>
                    </div>
                    <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-100/80 md:text-base">
                      {n.content}
                    </p>
                    <span
                      className={"mt-4 inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-bold " + info.cls}
                    >
                      {info.label}
                    </span>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}